import React, { useState} from "react";
// node.js library that concatenates classes (strings)
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  
} from "reactstrap";
import Header from "components/Headers/Header.js";
import HeaderEmpty from "components/Headers/HeaderEmpty";
import DaySelfSales from "./DaySelfSales";
import AuthFooter from 'components/Footers/AuthFooter'
import TopSeller from "./TopSeller";
import DepositToShop from "./DepositToShop";

const Index = (props) => {
    const [camera, setcamera] = useState(false)
  
    const scanQR = ()=>{
      setcamera(!camera)
    }
    return (
      <>
      <HeaderEmpty />  
        {/* Page content */}
        <Container fluid>
         
          <Row  >
            <Col className="mb-5 mt-8 mb--7 mb-xl-0" xl="8">
              <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      <h2 className="text-white">Day Sales</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <DaySelfSales/>
                </CardBody>
              </Card>
            </Col>
            <Col xl="4" className="mt-8">
              <Card className="shadow">
                <CardHeader className="bg-transparent">
                  <Row>
                    <div className="d-flex" style={{alignItems: "center"}}>
                      <h2 className="mb-0 mr-5">Today Top Seller</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                   <TopSeller/>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="8">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Something</h3>
                    </div>
                    <div className="col text-right">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        See all
                      </Button>
                    </div>
                  </Row>
                </CardHeader>
                
              </Card>
            </Col>
            <Col xl="4">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Money to Deposit</h3>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <DepositToShop/>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <AuthFooter/>
      </>
    );
  
}

export default Index;
